import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemsListRowItemBase } from '../list-row-item-base';

@Component({
    selector: 'fi-items-list-row-item-tel',
    templateUrl: './tel.component.html',
    styleUrls: ['./tel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ItemsListRowItemTelComponent extends ItemsListRowItemBase {}
